import { GET, POST } from './httpRequest';
import { convertToFormData } from '../utlis/dataFormate';

const baseurl = 'https://api.dusprint2025.topgrowth.in';


export const registerUser = (data) => {
  const url = `${baseurl}/api/student/register`;
  return POST({ url, data });
};

export const verifyMagicLink = (token) => {
  const url = `${baseurl}/api/student/verify-account`;
  return POST({ url, data: { token } });
}

export const singleGameRegistration = (data) => {
  const url = `${baseurl}/api/registration`;
  return POST({ url, data });
}

export const teamGameRegistration = (data) => {
  const url = `${baseurl}/api/registration`;
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  return POST({ url, data: convertToFormData(data), headers });
}

export const login = (data) => {
  const url = `${baseurl}/api/student/login`;
  return POST({ url, data });
}

export const forgotPassword = (data) => {
  const url = `${baseurl}/api/student/forget-password`;
  return POST({ url, data });
}

export const getRegisteredGames = () => {
  const url = `${baseurl}/api/registration`;
  return GET({ url });
}

export const getAnalytics = () => {
  const url = `${baseurl}/api/registration/analytics`;
  return GET({ url });
}

export const getStudentRegistrations = () => {
  const url = `${baseurl}/api/registration`;
  return GET({ url });
}